
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
  <path
    fill="currentColor"
    d="M677.831111 483.555556v56.888888h170.666667v341.333334h-341.333334v-170.666667h-56.888888v227.555556h455.111111V483.555556h-227.555556zM52.053333 85.333333h568.888889v568.888889h-568.888889z"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'BringForward',
    }) as DefineComponent
    </script>
    